"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParamValue = createParamValue;
exports.createParams = createParams;
exports.getParamValue = getParamValue;
exports.getQueryParams = getQueryParams;
exports.getRangeParamValue = getRangeParamValue;
exports.removeDuplicateValues = removeDuplicateValues;
exports.sortOptionsBy = sortOptionsBy;
exports.sortParams = void 0;
var _constants = require("../constants");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function getParamValue(value) {
  if (value && value !== "") {
    var valueArray = value.split(_constants.SYMBOL_QUERY_PARAM_VALUE_DIVIDER);
    return valueArray.length > 1 ? valueArray : value;
  }
  return true;
}
var sortParams = function sortParams(filters) {
  return filters ? Object.keys(filters).sort(function (a, b) {
    return a.localeCompare(b);
  }).reduce(function (obj, key) {
    obj[key] = Array.isArray(filters[key]) ? filters[key].sort(function (a, b) {
      return a > b ? 1 : -1;
    }) : filters[key];
    return obj;
  }, {}) : null;
};
exports.sortParams = sortParams;
function sortOptionsBy(options, key) {
  if (!Array.isArray(options)) return null;
  var sortedOptions = options.sort(function (a, b) {
    var _a$key, _b$key;
    var valueA = (_a$key = a[key]) === null || _a$key === void 0 ? void 0 : _a$key.toUpperCase();
    var valueB = (_b$key = b[key]) === null || _b$key === void 0 ? void 0 : _b$key.toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    return 1;
  });
  return sortedOptions;
}
function createParams(params) {
  var createdParams = [];
  for (var key in params) {
    if (key === "others") {
      createdParams = createdParams.concat(params[key]);
    } else {
      var paramValue = createParamValue(params[key]);
      if (paramValue) {
        createdParams.push({
          key: key,
          value: paramValue
        });
      }
    }
  }
  return createdParams.length ? createdParams : null;
}
function createParamValue(params) {
  var paramsArray = [];
  if (typeof params === "string") {
    return params;
  }
  for (var key in params) {
    paramsArray.push({
      key: key,
      value: Array.isArray(params[key]) ? params[key].sort().join(",") : params[key]
    });
  }
  if (paramsArray.length === 0) {
    return null;
  }
  var formatArray = [];
  paramsArray = sortOptionsBy(paramsArray, "key");
  paramsArray.forEach(function (p) {
    if (p.value !== _constants.BOOLEAN_FALSE) {
      if (p.value === _constants.BOOLEAN_TRUE) {
        formatArray.push(p.key);
      } else {
        formatArray.push("".concat(p.key, ":").concat(p.value));
      }
    }
  });
  return formatArray.length > 0 ? formatArray.join("|") : null;
}

/**
 * @param {string} query
 * @returns {Array<{key: string, value: string}>}
 */
function getQueryParams(query) {
  if (!query) {
    return [];
  }
  var searchParams = new URLSearchParams(query);
  var params = Array.from(searchParams, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return {
      key: key,
      value: value
    };
  });
  return params;
}
function getRangeParamValue(min, max) {
  if (min && max) {
    return "".concat(min, "~").concat(max);
  }
  return null;
}
function removeDuplicateValues(inputString) {
  if (!inputString) {
    return "";
  }
  var splitString = inputString.split(",");

  // Use the Set object to remove duplicates
  var uniqueSet = new Set(splitString);

  // Convert the Set back to an array
  var uniqueArray = Array.from(uniqueSet);

  // Join the array back into a string
  var uniqueString = uniqueArray.join(",");
  return uniqueString;
}